export default {
    INVOICE_CONTACT_SEARCH: 'INVOICE_CONTACT_SEARCH',
    CONTACT_DATA: 'CONTACT_DATA',
    LOADER: 'LOADER',
    BC_ACTION_FAILED: 'BC_ACTION_FAILED',
    CONTACT_ACCOUNT_PARTY_DATA: 'CONTACT_ACCOUNT_PARTY_DATA',
    COMMUNICATION: 'COMMUNICATION',
    SUCCESS_MESSAGE: 'SUCCESS_MESSAGE',
};
